export default __webpack_public_path__ + "static/media/bg.1f032b25.jpg";